import type { GroupWorkbookPageProgress } from '@mathflat/domain/StudentWorkbook'
import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class GroupWorkbookPage extends DTO {
  status: GroupWorkbookPageProgress['status']
  readonly workbookPage: GroupWorkbookPageProgress['workbookPage']
  studentWorkbookProgresses: GroupWorkbookPageProgress['studentWorkbookProgresses']

  get pageNum() {
    return this.workbookPage.page
  }

  get pageId() {
    return this.workbookPage.id
  }

  constructor(data: GroupWorkbookPageProgress) {
    super()
    this.status = data.status
    this.workbookPage = data.workbookPage
    this.studentWorkbookProgresses = data.studentWorkbookProgresses

    makeObservable(this, { status: observable, pageId: computed, pageNum: computed })
  }

  get progressIdList() {
    return this.studentWorkbookProgresses.map((progress) => progress.id)
  }
}
